/**
 * <ai_context>
 * Contains a hook that transforms Jotai atoms into their dereferenced values
 * using the "get" method from the Jotai store.
 * </ai_context>
 */

import type { TightJavaScriptifyHook } from "@phosphor/utils";
import { objectPredicateMacro } from "../js/objectPredicateMacro.ts";
import { isAtom } from "./isAtom.ts";
import type { JotaiGetter, JotaiStore } from "./jotai-types.ts";

const isStore = objectPredicateMacro<JotaiStore>(["get", "set", "sub", "unstable_derive"]);

/**
 * Creates a hook that transforms Jotai atoms into their dereferenced values
 * using the provided get function.
 */
export function createJotaiAtomsHook(get: JotaiGetter): TightJavaScriptifyHook {
  return {
    name: "jotai-atom",
    replacer(key: string, value: unknown) {
      if (isStore(value)) return { value: "$JotaiStore" };
      if (isAtom(value)) {
        return { value: get(value) };
      }
      return null;
    },
  };
}
